var typeId = 0;
var ActionReducer = function (initState, prefix) {
    var mutations = Object.create(null);
    var createAction = function (type, mutation) {
        if (typeof type === 'function') {
            mutation = type;
            type = "@@ActionReducer-" + (++typeId);
        }
        type = prefix ? ("" + prefix + type) : type;
        var actionCreator = function () {
            var payload = [], len = arguments.length;
            while ( len-- ) payload[ len ] = arguments[ len ];

            return ({ type: type, payload: payload });
        };
        actionCreator.type = type;
        mutations[type] = mutation;
        return actionCreator;
    };
    var reducer = function (state, action) {
        if ( state === void 0 ) state = initState;

        var mutation = mutations[action.type];
        return mutation ? mutation.apply(void 0, [ state ].concat( action.payload )) : state;
    };
    return { createAction: createAction, reducer: reducer };
};

export default ActionReducer;
